export const getStatus = (data) => {
  if (!data?.items?.length) return "red";
  const avgSum = data.items.reduce((sum, item) => sum + Number(item.avg), 0);
  const avg = avgSum / data.items.length;
  const rounded = Math.round(avg * 10) / 10;
  return rounded < 8 ? "red" : "green";
};
